module.exports = __webpack_public_path__ + "shunjianActive.b7327dba.png";